module.exports = __webpack_public_path__ + "static/mentor-sumeer-core-5c3bdb493808c1f51c7a779405cabdc0.jpg";